export enum ClientContactType {
  ContactFileOne = "ContactFileOne",
  ContactFileTwo = "ContactFileTwo",
}
